// Copyright (c) Meta Platforms, Inc. and affiliates.
// All rights reserved.

// This source code is licensed under the license found in the
// LICENSE file in the root directory of this source tree.

import * as React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { configureStore } from "./store/index";
import App from "./App";
import DesignHubContextProvider from "./components/hooks/DesignHub/context";

import { Amplify, I18n } from 'aws-amplify';
import { enAppDict, enStripeDict, esAppDict, esAuthDict, esStripeDict } from "./i18n/dictionaries/dictionaries";
import awsmobile from "./aws-exports";
import { decorFormDataEN_KV } from "./data/form/decorFormDataEN_KV";
import { decorFormDataES_KV } from "./data/form/decorFormDataES_KV";

Amplify.configure(awsmobile);

Amplify.configure({
  API: {
    endpoints: [
      {
        name: "HomeDecorApi-Beta",
        endpoint: "https://2btfysg76h.execute-api.us-east-1.amazonaws.com/dev",
      },
      {
        name: "HomeDecorApi-Prod",
        endpoint: "https://2btfysg76h.execute-api.us-east-1.amazonaws.com/prod",
      }
    ]
  }
});

I18n.putVocabularies({
  'en': Object.assign({}, enAppDict, enStripeDict, decorFormDataEN_KV),
  'es': Object.assign({}, esAuthDict, esAppDict, esStripeDict, decorFormDataES_KV)
});

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(
  <Provider store={configureStore({})}>
    <BrowserRouter>
      <DesignHubContextProvider>
        <App />
      </DesignHubContextProvider>
    </BrowserRouter>
  </Provider>
);
